
import React from 'react';
import { Language } from '../types';
import { translations } from '../translations';

interface Props {
  lang?: Language;
}

export const Spinner: React.FC<Props> = ({ lang = 'zh' }) => {
  const t = translations[lang];
  return (
    <div className="flex flex-col items-center justify-center space-y-4 p-8">
      <div className="relative w-20 h-20">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-stone-200 rounded-full"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-emerald-600 rounded-full border-t-transparent animate-spin"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl">
          🪨
        </div>
      </div>
      <p className="text-stone-600 font-serif-sc animate-pulse">{t.analyzing}</p>
    </div>
  );
};
